import { proxy } from 'valtio';
export const useSortVirtualHoldingDataStore = proxy({
    sortKey: 'lastModifiedDatetime',
    orderKey: 'desc',
});
export const useSortSignalrDataStore = proxy({
    sortKey: '',
    orderKey: 'asc',
});
